import { useContext, useEffect } from "react";
import { UserStore } from "../..";
import BreadCrumbs from "../../components/breadcrumsb";
import { PageContainer } from "../../components/page";
import { useNavigate } from "react-router";
import { runAuthHandler } from "../util";
import NewFenceConfigContainer from "./NewFenceConfigContainer";
import { Libraries, useJsApiLoader } from "@react-google-maps/api";
import { PEProgressBar } from "../../components/linear-progress";
import { observer } from "mobx-react";

// Module-level so the loader sees a stable reference across renders.
// places: search box. geometry: area validation. (Google removed the
// "drawing" library in Maps API 3.65; draw mode is implemented in-app.)
const MAP_LIBRARIES: Libraries = ["places", "geometry"];

const FenceConfigPage = () => {
  const userStore = useContext(UserStore);
  const { selectedVenue } = userStore;

  const navigate = useNavigate();

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    // TODO: move the Google Maps key to REACT_APP_GOOGLE_MAPS_API_KEY, rotate it,
    // and restrict it to the deployed origins. Deferred: not actionable yet.
    googleMapsApiKey: "AIzaSyC2M5Q4tBg_vWDT1rsw59Jse5E5PDwXnlA",
    libraries: MAP_LIBRARIES,
  });

  const handleVenue = () => {
    if (selectedVenue?.venueId !== 17) {
      navigate("/");
    }
  };
  useEffect(() => {
    runAuthHandler({
      userStore,
      navigate,
    });
    handleVenue();
  }, [selectedVenue]);

  return (
    <PageContainer>
      <BreadCrumbs
        routes={[
          { path: "/home", breadcrumbName: "Home" },
          { path: "/fence-config", breadcrumbName: "Geofence Creator" },
        ]}
      />
      {!isLoaded && <PEProgressBar />}
      {isLoaded && <NewFenceConfigContainer />}
    </PageContainer>
  );
};

export default observer(FenceConfigPage);
